import { dropL, each, filterL, go, head, last, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
export const _handleTouchMove = (self, event) => {
  const target_image_layer_el = self._getTargetImageLayerElThrowable();
  const cutting_line_clip_path_el = self._getCuttingLineClipPathElThrowable();
  const cutting_line_display_path_el =
    self._getCuttingLineDisplayPathElThrowable();
  const view_box = self._getViewBoxThrowable();
  if (self._touch_map.size <= 0) {
    return;
  }
  event.preventDefault();
  const { changedTouches: changed_touches, touches } = event;
  const changed_touch_map = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    mapL((touch) => [touch.identifier, touch]),
    (entries) => new Map(entries)
  );
  const touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(touches),
    mapL(({ identifier: id }) => id),
    (iter) => new Set(iter)
  );
  self._touch_map = go(
    self._touch_map.entries(),
    rejectL(([id]) => !touch_id_set.has(id)),
    mapL(([id, touch_pair]) => {
      const changed_touch = changed_touch_map.get(id);
      if (changed_touch == null) {
        return [id, touch_pair];
      }
      return [id, [touch_pair[0], changed_touch]];
    }),
    (entries) => new Map(entries)
  );
  switch (self._processing_task) {
    case BaseNS.PROCESSING_TASK.ZOOMING_AND_PANNING:
    case BaseNS.PROCESSING_TASK.PATH_EDITING_ZOOMING_AND_PANNING: {
      if (self._zooming_and_panning_touch_id1 == null) {
        return;
      }
      const touch1 = self._touch_map.get(
        self._zooming_and_panning_touch_id1
      )?.[1];
      if (touch1 == null) {
        return;
      }
      const { clientX: client_x1, clientY: client_y1 } = touch1;
      const point1 = self.toViewPortPoint({
        x: client_x1,
        y: client_y1,
      });
      if (self._zooming_and_panning_touch_id2 == null) {
        return;
      }
      const touch2 = self._touch_map.get(
        self._zooming_and_panning_touch_id2
      )?.[1];
      if (touch2 == null) {
        return;
      }
      const { clientX: client_x2, clientY: client_y2 } = touch2;
      const point2 = self.toViewPortPoint({
        x: client_x2,
        y: client_y2,
      });
      const panning_point1 = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
        (self._zooming_and_panning_progress_touch_x1 +
          self._zooming_and_panning_progress_touch_x2) /
          2,
        (self._zooming_and_panning_progress_touch_y1 +
          self._zooming_and_panning_progress_touch_y2) /
          2,
      ]);
      const d1 = Math.sqrt(
        (self._zooming_and_panning_progress_touch_x1 -
          self._zooming_and_panning_progress_touch_x2) **
          2 +
          (self._zooming_and_panning_progress_touch_y1 -
            self._zooming_and_panning_progress_touch_y2) **
            2
      );
      const panning_point2 = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
        (point1.x + point2.x) / 2,
        (point1.y + point2.y) / 2,
      ]);
      const d2 = Math.sqrt(
        (point1.x - point2.x) ** 2 + (point1.y - point2.y) ** 2
      );
      const tx = panning_point1.x - panning_point2.x;
      const ty = panning_point1.y - panning_point2.y;
      let ctm = target_image_layer_el.getCTM();
      if (ctm == null) {
        return;
      }
      let panning_transform_matrix = self._svg_el.createSVGMatrix();
      panning_transform_matrix.e = tx;
      panning_transform_matrix.f = ty;
      panning_transform_matrix = ctm
        .inverse()
        .multiply(panning_transform_matrix)
        .multiply(ctm);
      view_box.addTransform({
        matrix: panning_transform_matrix,
      });
      const s = d1 / d2;
      ctm = target_image_layer_el.getCTM();
      if (ctm == null) {
        return;
      }
      const scale_transform_matrix = self._svg_el.createSVGMatrix();
      scale_transform_matrix.a = s;
      scale_transform_matrix.d = s;
      const post_scale_transform_matrix = self._svg_el.createSVGMatrix();
      post_scale_transform_matrix.e = panning_point2.x;
      post_scale_transform_matrix.f = panning_point2.y;
      const pre_scale_transform_matrix = post_scale_transform_matrix.inverse();
      let zooming_transform_matrix = post_scale_transform_matrix
        .multiply(scale_transform_matrix)
        .multiply(pre_scale_transform_matrix);
      zooming_transform_matrix = ctm
        .inverse()
        .multiply(zooming_transform_matrix)
        .multiply(ctm);
      view_box.addTransform({
        matrix: zooming_transform_matrix,
      });
      self._zooming_and_panning_progress_touch_x1 = point1.x;
      self._zooming_and_panning_progress_touch_y1 = point1.y;
      self._zooming_and_panning_progress_touch_x2 = point2.x;
      self._zooming_and_panning_progress_touch_y2 = point2.y;
      return;
    }
    case BaseNS.PROCESSING_TASK.PATH_EDITING: {
      const touch = go(
        self._touch_map.entries(),
        filterL(([touch_id]) => changed_touch_map.has(touch_id)),
        mapL(dropL(1)),
        mapL(head),
        filterL(
          ([{ clientX: x1, clientY: y1 }, { clientX: x2, clientY: y2 }]) =>
            Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2) > self._touch_margin
        ),
        mapL(dropL(1)),
        mapL(head),
        head
      );
      if (touch == null) {
        return;
      }
      const {
        identifier: touch_id,
        clientX: client_x,
        clientY: client_y,
      } = touch;
      const point = self.toViewPortPoint({
        x: client_x,
        y: client_y,
      });
      self._processing_task =
        BaseNS.PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING;
      self._path_editing_touch_id = touch_id;
      self._path_editing_progress_touch_x = point.x;
      self._path_editing_progress_touch_y = point.y;
      return;
    }
    case BaseNS.PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING: {
      if (self._path_editing_touch_id == null) {
        return;
      }
      const touch = self._touch_map.get(self._path_editing_touch_id)?.[1];
      if (touch == null) {
        return;
      }
      const { clientX: client_x, clientY: client_y } = touch;
      const point = self.toViewPortPoint({
        x: client_x,
        y: client_y,
      });
      const from_x = self._path_editing_progress_touch_x;
      const from_y = self._path_editing_progress_touch_y;
      self._path_editing_progress_touch_x = point.x;
      self._path_editing_progress_touch_y = point.y;
      const to_x = point.x;
      const to_y = point.y;
      const ctm = cutting_line_display_path_el.getCTM();
      if (ctm == null) {
        return;
      }
      const transform = self._svg_el.createSVGTransform();
      transform.setTranslate(to_x - from_x, to_y - from_y);
      const matrix = ctm.inverse().multiply(transform.matrix).multiply(ctm);
      each(({ model }) => {
        model.transform(matrix);
      })(self._path_editor_list);
      const d = go(
        self._path_editor_list,
        last,
        (a) => a?.model,
        (m) => m?.toString()
      );
      if (d != null) {
        self._cutting_line_path_data = d;
        cutting_line_clip_path_el.setAttributeNS(null, "d", d);
        cutting_line_display_path_el.setAttributeNS(null, "d", d);
      }
      return;
    }
    default: {
      return;
    }
  }
};
